import { render, staticRenderFns } from "./card-auth.vue?vue&type=template&id=39c2d16d&"
import script from "./card-auth.vue?vue&type=script&lang=js&"
export * from "./card-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports